var _Polygon, _Line;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
import Svg, { Polygon, Line } from "react-native-svg";
var SvgSkipBack = function SvgSkipBack(props) {
  return /*#__PURE__*/React.createElement(Svg, _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round",
    className: "feather feather-skip-back"
  }, props), _Polygon || (_Polygon = /*#__PURE__*/React.createElement(Polygon, {
    points: "19 20 9 12 19 4 19 20"
  })), _Line || (_Line = /*#__PURE__*/React.createElement(Line, {
    x1: 5,
    y1: 19,
    x2: 5,
    y2: 5
  })));
};
export default SvgSkipBack;